export function ExpiringPointModel() {
    this.point = 0;
    this.dateExpire = null;

    this.setDataFromApi = function (data) {
        this.point = data.expiring_points.points;
        this.dateExpire = data.expiring_points.time;
    };
}
